module.exports = __webpack_public_path__ + "media/images/common/arrow_3-008767d770d2d50af978c70b39401de1.gif";